import React from 'react';
import * as apiCaller from '../../../../helpers/apiCaller'
import serviceUrls from '../../../../constants/serviceUrls'
import { LoadingPage } from '../../../../components/tools/Others';
import MeterInfo from '../../../admin/components/common/MeterInfo';
import { UneditableTextInput } from '../../../../components/tools/BootstrapControls';
import { convertMeterStatus, convertWasReadingIntegrationStatus } from '../../../../helpers/converters';
import { ArrowRight, Info, SearchIcon } from '../../../../components/tools/Icons';

export default class MeterCommissionMeterDetails  extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            initialised:false,
            meter:null
        };
    }

    async componentDidMount() {
        await apiCaller.post(serviceUrls.admin.getMeterAndIntegration,{id:this.props.meter.id})
        .then((data)=>{
            this.setState({
                meter:data.meter,
                meterIntegration:data.meterIntegration,
                initialised:true
            })
        })
    }


    render() {
        if(!this.state.initialised) return <LoadingPage />
        const meter = this.state.meter;
        const meterIntegration = this.state.meterIntegration;
        return <>

            <div className='row mb-4'>
                <div className='col-md-3 mb-3'>
                    <UneditableTextInput
                        label={<>Meter ID </>}
                        value={<a>
                            {meter.id}
                            <a href={`/#/admin/meter/${meter.id}`} target='_blank' className='ps-2 fs-80 float-end'>Open</a>
                        </a>}
                    />
                </div>
                <div className='col-md-3 mb-3'>
                    <UneditableTextInput
                        label={<>Meter Status</>}
                        value={convertMeterStatus(meter.status)}
                    />
                </div>
                {meterIntegration != null && <div className='col-md-3 mb-3'>
                    <UneditableTextInput
                        label={<>Reading Integration Status</>}
                        value={convertWasReadingIntegrationStatus(meterIntegration.wasReadingIntegrationStatus)}
                    />
                </div>}
            </div>
            <MeterInfo meter={meter} />
            
        </>
    }
}